/**
 * 总部活动页快照：仅用于「跳转收银订单 → 返回」时还原活动、Tab、筛选、页码并重新请求。
 * 结构：{ activeTab, couponCode, coupon: { dateRange, status, page, queryForm }, fund: { dateRange, fundTypes, page, queryForm } }
 * 本页不使用 keep-alive。
 */
let pageCache = null

export function setHqEventPageCache(cache) {
  pageCache = cache || null
}

export function getHqEventPageCache() {
  return pageCache
}

export function clearHqEventPageCache() {
  pageCache = null
}
